import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { staggerRevealOnScroll } from '../../utils/animations';
import styles from './CaseStudies.module.scss';

const caseStudies = [
  {
    client: 'Local E-Commerce Brand',
    metric: '+340%',
    metricLabel: 'Organic Traffic',
    description: 'Scaled non-branded search traffic and improved category page rankings from page 3 to top 3 within 6 months.',
  },
  {
    client: 'B2B SaaS Platform',
    metric: '3x',
    metricLabel: 'Lead Generation',
    description: 'Restructured site architecture and implemented a content cluster strategy targeting high-intent decision makers.',
  }
];

const CaseStudies: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Image scroll parallax
      const images = document.querySelectorAll(`.${styles.imageInner}`);
      images.forEach((img) => {
        gsap.to(img, {
          yPercent: 30, // Move image down slightly as user scrolls
          ease: 'none',
          scrollTrigger: {
            trigger: img.parentElement,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.caseStudiesSection} id="case-studies" ref={sectionRef}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.sectionTitle}>Proven <span className={styles.highlight}>Results</span></h2>
          <p className={styles.sectionSubtitle}>Real growth for real businesses.</p>
        </div>

        <div className={styles.grid}>
          {caseStudies.map((study, index) => (
            <div key={index} className={`${styles.card} hover-target`}>
              <div className={styles.imagePlaceholder}>
                {/* The inner element that actually parallaxes */}
                <div className={styles.imageInner}>
                  <span>[ Project Image ]</span>
                </div>
              </div>
              <div className={styles.cardContent}>
                <div className={styles.metricWrapper}>
                  <span className={styles.metric}>{study.metric}</span>
                  <span className={styles.metricLabel}>{study.metricLabel}</span>
                </div>
                <h3 className={styles.client}>{study.client}</h3>
                <p className={styles.description}>{study.description}</p>
                <button className={styles.readMore}>View Case Study →</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
